'use client'

import { useQueryClient } from '@tanstack/react-query'
import { useRouter } from 'next/navigation'
import { useCallback } from 'react'
import { toast } from 'react-toastify'
import { endSessionService } from '~/services/domain/auth/SessionService'

/** Sair: encerra a sessão (cookies e todas as stores), descarta o cache do React Query e volta para a home. */
export function useLogout() {
    const router = useRouter()
    const queryClient = useQueryClient()

    const logout = useCallback(() => {
        endSessionService()
        queryClient.clear()
        router.push('/')
        toast.success('Logout efetuado com sucesso!', { autoClose: 2000 })
    }, [queryClient, router])

    return { logout }
}
